import { render } from "./UserData.vue?vue&type=template&id=755c0ccc&scoped=true"
import script from "./UserData.vue?vue&type=script&lang=js"
export * from "./UserData.vue?vue&type=script&lang=js"

import "./UserData.vue?vue&type=style&index=0&id=755c0ccc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-755c0ccc"]])

export default __exports__